<dff-side [observable]="vm$">
  @if (vm$ | async; as vm) {
    <dff-side-titel>{{ vm.indstillinger.menuTekst }}</dff-side-titel>
    <dff-side-tekst [titel]="vm.indstillinger.topOverskrift" [tekst]="vm.indstillinger.topIndhold"></dff-side-tekst>
    @if (formGroupErrors.length > 0) {
      <fieldset class="errors-field">
        <legend>Der er fejl i formularen</legend>
        <ul>
          @for (error of formGroupErrors; track error) {
            <li>
              <button
                [attr.id]="error.inputId + '-error-button'"
                (click)="navigationToError(error.inputId)"
                class="errors-field__button"
                role="button"
                type="button"
                [attr.aria-label]="'Naviger til ' + error.label + ' feltet'"
                >
                {{ error.label }} {{ error.error }}
              </button>
            </li>
          }
        </ul>
      </fieldset>
    }
    <form id="meld-flytning-formular" [formGroup]="vm.formGroup">
      <mat-accordion [multi]="!erMobilVisning">
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <h2 class="panel-header">Udflytters nye adresse *</h2>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <e-forsyning-flyttemeddelelse-udflytter
            [formGroup]="vm.formGroup.get('udflytter')"
            [erAflaesningFravalgt]="vm.indstillinger.erAflaesningFravalgt"
          ></e-forsyning-flyttemeddelelse-udflytter>
        </mat-expansion-panel>
        <mat-expansion-panel [expanded]="!erMobilVisning">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <h2 class="panel-header">Indflytters navn</h2>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <e-forsyning-flyttemeddelelse-indflytter
              [formGroup]="vm.formGroup.get('indflytter')"
            ></e-forsyning-flyttemeddelelse-indflytter>
          </ng-template>
        </mat-expansion-panel>
        <mat-expansion-panel [expanded]="!erMobilVisning">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <h2 class="panel-header">Indflytters evt. anden faktureringsadresse</h2>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <e-forsyning-flyttemeddelelse-faktureringsadresse
              [formGroup]="vm.formGroup.get('faktura')"
            ></e-forsyning-flyttemeddelelse-faktureringsadresse>
          </ng-template>
        </mat-expansion-panel>
        <mat-expansion-panel [expanded]="!erMobilVisning">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <h2 class="panel-header">Fraflytters oplysninger</h2>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <e-forsyning-flyttemeddelelse-anmelder
              [formGroup]="vm.formGroup.get('anmelder')"
            ></e-forsyning-flyttemeddelelse-anmelder>
          </ng-template>
        </mat-expansion-panel>
        <mat-expansion-panel [expanded]="!erMobilVisning">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <h2 class="panel-header">Evt. udbetaling overføres til</h2>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <e-forsyning-flyttemeddelelse-udbetaling
              [formGroup]="vm.formGroup.get('udbetaling')"
            ></e-forsyning-flyttemeddelelse-udbetaling>
          </ng-template>
        </mat-expansion-panel>
        @if (!vm.formGroup.get('aflaesning.erAflaesningFravalgt').value) {
          <mat-expansion-panel [expanded]="!erMobilVisning">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <h2 class="panel-header">Indtast aflæsning *</h2>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <e-forsyning-flyttemeddelelse-aflaesning
                [formGroup]="vm.formGroup.get('aflaesning')"
              ></e-forsyning-flyttemeddelelse-aflaesning>
            </ng-template>
          </mat-expansion-panel>
        }
      </mat-accordion>
      <br />
      <dff-button-panel>
        <dff-spinner-button
          id="send"
          [spinning]="erSpinnerSynlig"
          (click)="opretFlyttemeddelelse(vm.formGroup)"
          type="submit"
          role="button"
          [attr.aria-label]="'Send flyttemeddelelse'"
          >
          Send
        </dff-spinner-button>
      </dff-button-panel>
    </form>
  }
</dff-side>
